require("./wdh-legacy/center-spot/js/base/component-center-spot.js");
require("./wdh-legacy/center-spot/js/corporate-template/component-center-spot.js");